import React, { useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';

import { MediaSourcePicker } from './MediaSourcePicker';
import { MotionControls } from './MotionControls';
import { buildRestyle } from './buildRequests';
import type { VideoPanelProps } from './panelTypes';
import type { MediaSource } from '../../../services/mediaSourceService';

/** Re-style an existing clip with a prompt (A-F5). */
export const RestylePanel: React.FC<VideoPanelProps> = ({
  controls,
  onControlsChange,
  onSubmit,
  isRendering,
}) => {
  const [source, setSource] = useState<MediaSource | null>(null);
  const [prompt, setPrompt] = useState('');
  const canSubmit = !!source && prompt.trim().length > 0 && !isRendering;

  return (
    <Stack spacing={1.5}>
      <MediaSourcePicker kind="video" label="Clip to restyle" value={source} onChange={setSource} disabled={isRendering} />
      <TextField
        label="Style prompt"
        placeholder="e.g. claymation, film noir, watercolor…"
        value={prompt}
        onChange={e => setPrompt(e.target.value)}
        multiline
        minRows={2}
        size="small"
        fullWidth
      />
      <MotionControls kind="Restyle" value={controls} onChange={onControlsChange} />
      {!canSubmit && !isRendering && (
        <Typography variant="caption" color="text.secondary">
          Choose a clip (upload or library) and describe the style.
        </Typography>
      )}
      <Button
        variant="contained"
        disabled={!canSubmit}
        onClick={() => onSubmit('Restyle', buildRestyle(source!.assetId, prompt, controls))}
      >
        {isRendering ? 'Rendering…' : 'Restyle clip'}
      </Button>
    </Stack>
  );
};
